import { useMemo, useState } from 'react';
import classes from '../RealPlayViewQualified/ReviewQualifiedRealPlay.module.scss';
import useRoleplayHelper from 'features/realplays/RealPlay.helper';
import { imageBasePath } from 'constants';
import { InputSelect } from 'shared_ui_components';
import { withoutScenarios } from 'features/roleplay/RoleplayConstants';
import RoleplayLabel from 'features/roleplay/Components/Common/RoleplayLabel';
import VideoPlayer from '../Common/VideoPlayer';
import classNames from 'classnames';
import RatingCriteriaTooltip from 'features/roleplay/Components/Common/RatingCriteriaTooltip';
import RoleplayRating from 'features/roleplay/Components/Common/RoleplayRating/RoleplayRating';
import { CustomTooltipWhite } from 'shared_ui_components';
import AIFeedback from 'shared_ui_components/AIFeatures/AIFeedback/AIFeedback';
import cat from 'assets/cat.jpeg';
import { Tabs, Tab, withStyles, Collapse, Avatar } from '@material-ui/core';
import User from 'infrastructure/User';
import CopyComponent from '../Common/CopyComponent';
import CopyTranscription from '../Common/CopyTranscription';
import DownloadComponent from '../Common/DownloadComponent';
import InputComponent from '../Common/InputComponente';
import useGetAssignmentTranscriptionQuery from 'features/realplays/services/queries/useGetAssignmentTranscription';
import { SentimentDissatisfied } from '@material-ui/icons';
import RealPlayQualifiedDataHelper from 'features/realplays/RealPlayQualifiedData.helper';
import LoadingTranscription from './LoadingTranscription';
const AntTabs = withStyles({
  root: {
    minHeight: '1rem',
  },
  indicator: {
    backgroundColor: '#0494FD',
  },
})(Tabs);

const AntTab = withStyles((theme) => ({
  root: {
    textTransform: 'none',
    minWidth: 72,
    minHeight: '2rem',
    fontWeight: 600,
    marginRight: '1rem',
    padding: '0px  10px',
    '&:hover': {
      color: '#40a9ff',
      opacity: 1,
    },
    '&$selected': {
      color: '#193448',
      fontWeight: 600,
    },
    '&:focus': {
      color: '#40a9ff',
    },
  },
  selected: {},
}))((props) => <Tab disableRipple {...props} />);

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}

const ReportResult = ({ data = {} }) => {
  const { navigate, PATHS } = useRoleplayHelper();
  const [selectedScenario, setSelectedScenario] = useState(data?.scenarios?.[0] || {});
  const [open, setOpen] = useState(false);
  const [valueTab, setValueTab] = useState(0);
  const [search, setSearch] = useState('');

  const userName = useMemo(
    () => `${data?.assigned_by_user?.first_name} ${data?.assigned_by_user?.last_name}`,
    [data?.assigned_by_user]
  );
  const clientName = useMemo(
    () => data?.realplay_setting?.ai_persona?.name,
    [data?.realplay_setting]
  );

  const { isLoading: isLoadingTranscription } = useGetAssignmentTranscriptionQuery({
    assignment_uuid: data?.uuid,
    scenario_uuid: selectedScenario?.uuid,
    response_uuid: selectedScenario?.response?.uuid,
    enabled:
      !!data?.uuid &&
      !!selectedScenario?.uuid &&
      !!selectedScenario?.response?.uuid &&
      valueTab === 1,
    clientName,
    userName,
  });

  const { transcription } = RealPlayQualifiedDataHelper();

  const openRatingDetails = () => setOpen(true);
  const closeRatingDetails = () => setOpen(false);

  const formatDate = () => {
    const dateString = new Date();

    let month = dateString.getUTCMonth() + 1;
    if (month < 10) month = `0${month}`;
    let day = dateString.getUTCDate();
    if (day < 10) day = `0${day}`;
    let year = dateString.getUTCFullYear();

    const newDate = day + '-' + month + '-' + year;
    return newDate;
  };

  const formattedDate = () => {
    if (data?.end_date) {
      const date = new Date(data?.end_date);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Los meses empiezan en 0
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    }
    return formatDate();
  };

  const scenarios = useMemo(() => data?.scenarios, [data?.scenarios]);
  const scenariosLength = useMemo(() => scenarios?.length || 0, [scenarios]);

  const options = useMemo(() => {
    if (!scenarios || scenarios?.length === 0) return [];
    return scenarios?.map((sc, i) => ({
      label: `${i + 1}. ${sc?.name}`,
      value: sc?.uuid,
    }));
  }, [scenarios]);

  const value = useMemo(() => {
    return (options ?? []).find((opt) => opt?.value === selectedScenario?.uuid);
  }, [options, selectedScenario]);

  const onSelectedValue = (value) => {
    const newList = {
      ...(scenarios ?? []).find((sce) => sce?.uuid === value),
    };
    setSelectedScenario(newList || {});
  };

  const title = data?.name;
  const videoURL = useMemo(() => selectedScenario?.response?.video, [selectedScenario?.response]);
  const rating_criteria = useMemo(
    () => selectedScenario?.response?.rating_criterials,
    [selectedScenario?.response]
  );
  const feedback = useMemo(() => selectedScenario?.response?.comment, [selectedScenario?.response]);

  const ratingHasAISuggestions = useMemo(() => {
    return rating_criteria?.every(({ reasoning, improvement_suggestion }) => {
      return reasoning || improvement_suggestion;
    });
  }, [rating_criteria]);

  const overallRating = useMemo(
    () => selectedScenario?.response?.average,
    [selectedScenario?.response]
  );

  const summary = useMemo(
    () => selectedScenario?.response?.summary,
    [selectedScenario?.response?.summary]
  );
  const customer_role = useMemo(
    () => data?.realplay_setting?.customer_role,
    [data?.realplay_setting]
  );
  const customer_industry = useMemo(
    () => data?.realplay_setting?.customer_industry,
    [data?.realplay_setting]
  );
  const customer_situation = useMemo(
    () => data?.realplay_setting?.customer_situation,
    [data?.realplay_setting]
  );

  const assigned_by_user = useMemo(() => data?.assigned_by_user, [data?.assigned_by_user]);
  const client_profile_pic = useMemo(
    () => data?.realplay_setting?.ai_persona?.profile_pic,
    [data?.realplay_setting?.ai_persona]
  );

  const handleChange = (event, newValue) => setValueTab(newValue);
  const handleInputChange = (e) => setSearch(e.target.value);

  const filteredTranscript = useMemo(() => {
    if (!transcription || transcription?.length === 0) return [];
    if (search === '') return transcription;
    return transcription?.filter(
      (item) =>
        item.content.toLowerCase().includes(search.toLowerCase()) ||
        item.role.toLowerCase().includes(search.toLowerCase()) ||
        item.name.toLowerCase().includes(search.toLowerCase())
    );
  }, [search, transcription]);

  return (
    <div>
      <div className={classes.headerContainer}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '0.4rem',
            width: '100%',
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 500 }}>
            <div className={classes.header}>
              <button
                onClick={() => {
                  navigate(PATHS.ROLEPLAYS);
                }}
              >
                <img src={imageBasePath + 'back_arrow.svg'} alt="Return" />
              </button>
              <span className="heading4">
                Interactive Roleplay "{title}" {formattedDate()}
              </span>
              <RoleplayLabel {...data?.status} />
            </div>
            {scenariosLength > 1 && (
              <div className={classes.scenarioSelector}>
                <InputSelect
                  value={value}
                  onChange={(opt) => onSelectedValue(opt?.value || '')}
                  options={options}
                  closeMenuOnSelect
                />
              </div>
            )}
            {!withoutScenarios.includes(selectedScenario?.name) &&
              scenarios?.length === 1 &&
              selectedScenario?.name !== title && (
                <span className="heading5">Scenario: {selectedScenario?.name}</span>
              )}
          </div>
        </div>
      </div>

      <div className={classes.container}>
        <div className={classes.left}>
          <div className={classes.reviewContainer}>
            {/* VIDEO*/}
            {videoURL && <VideoPlayer url={videoURL} />}

            {/* Rating criteria and stars given */}
            <div className={classes.starsContainer}>
              <div className={classes.headContainer}>
                <RatingCriteriaTooltip />
                {ratingHasAISuggestions && (
                  <div
                    className={classes.action}
                    onClick={open ? closeRatingDetails : openRatingDetails}
                  >
                    {open ? 'Hide' : 'Show'} details
                  </div>
                )}
              </div>
              <div className={classNames([classes.globalContainer, open && classes.gap])}>
                {rating_criteria?.map((c) => (
                  <Collapse
                    in={open}
                    collapsedSize={25}
                    key={c?.rating_criteria?.uuid}
                    className={classNames([open && classes.collapseSuggestions])}
                  >
                    <div className={classes.criteriaContainer}>
                      <b className="heading6">{c?.rating_criteria?.name}</b>
                      <RoleplayRating withTooltip stars={c?.stars} />
                    </div>

                    {/* AI reasoning and suggestions */}
                    {open && (
                      <div>
                        <p className="heading7Bold" style={{ marginTop: '0.25rem' }}>
                          {c?.reasoning
                            ? 'Why this rating?'
                            : 'AI "Why this rating?" is not available'}
                        </p>
                        {c?.reasoning && (
                          <p className="heading7" style={{ marginTop: '0.25rem' }}>
                            {c?.reasoning}
                          </p>
                        )}
                      </div>
                    )}

                    {open && (
                      <div>
                        <p className="heading7Bold" style={{ marginTop: '0.25rem' }}>
                          {c?.improvement_suggestion
                            ? 'How to improve?'
                            : 'AI "How to improve?" is not available'}
                        </p>
                        {c?.improvement_suggestion && (
                          <p className="heading7" style={{ marginTop: '0.25rem' }}>
                            {c?.improvement_suggestion}
                          </p>
                        )}
                      </div>
                    )}
                  </Collapse>
                ))}
              </div>

              <hr />
              <div className={classes.criteriaContainer}>
                <b className="heading6">Overall Score</b>
                <RoleplayRating withTooltip stars={overallRating} overallScore />
              </div>
            </div>

            {/* Comment given by the manager or AI*/}
            <div>
              <div className={classes.feedbackTitle}>
                <span>Feedback:</span>
                <CustomTooltipWhite
                  tooltipIcon="info_icon.svg"
                  title="Rating and feedback has been generated by AI."
                />
              </div>
              <div className="inputGroup textAreaGroup">
                <AIFeedback ai_feedback_status={'SUCCEEDED'} ai_feedback={feedback} assessment />
              </div>
            </div>
          </div>
        </div>
        <div className={classes.right}>
          <div>
            <AntTabs value={valueTab} onChange={handleChange} aria-label="ant example">
              <AntTab label="Coaching" />
              <AntTab label="Transcription" />
            </AntTabs>
          </div>
          <TabPanel value={valueTab} index={0}>
            <div className={classes.coachingContainer}>
              <div className={classes.title}>Summary</div>
              {summary && summary?.strengths?.length > 0 && (
                <div className={classes.subTitle}>💪 Strengths</div>
              )}
              <div className={classes.list}>
                <ul>
                  {summary?.strengths?.map((item, index) => {
                    return (
                      <li key={`Strengths-${index}`}>
                        {typeof item === 'string' ? item : item?.strength}
                      </li>
                    );
                  })}
                </ul>
              </div>

              {summary && summary?.areas_of_improvement?.length > 0 && (
                <div className={classes.subTitle}>📌 Areas of improvement</div>
              )}
              <div className={classes.list}>
                <ul>
                  {summary?.areas_of_improvement?.map((item, index) => (
                    <li key={`AreasOI-${index}`}>
                      {typeof item === 'string' ? item : item?.improve}
                    </li>
                  ))}
                </ul>
              </div>

              <div className={classes.title} style={{ marginTop: '0.5rem' }}>
                Prospect context
              </div>
              <div className={classes.customerContainer}>
                <div>
                  <p className={classes.deadlineTitle}>Role:</p>
                  <span>{customer_role}</span>
                </div>
                <div>
                  <p className={classes.deadlineTitle}>Industry:</p>
                  <span>{customer_industry}</span>
                </div>
                <div>
                  <p className={classes.deadlineTitle}>Situation: </p>
                  <span>{customer_situation}</span>
                </div>
              </div>
            </div>
          </TabPanel>
          <TabPanel value={valueTab} index={1}>
            {isLoadingTranscription ? (
              <LoadingTranscription />
            ) : !transcription || transcription?.length === 0 ? (
              <div className={classes.errorContainer}>
                <div>
                  <SentimentDissatisfied fontSize="small" />
                  <p style={{ fontSize: '12px' }}>
                    We’re unable to get the transcription right. Refresh or try again later.
                  </p>
                  <p>ERROR CODE 000-000</p>
                </div>
              </div>
            ) : (
              <div className={classes.transcriptionContainer}>
                <div className={classes.buttonsContainer}>
                  <InputComponent value={search} handleChange={handleInputChange} />
                  <div className={classes.actions}>
                    <CopyTranscription transcription={transcription} />
                    <DownloadComponent transcription={transcription} />
                  </div>
                </div>
                <div className={classes.columnContainer}>
                  {filteredTranscript?.length > 0 ? (
                    filteredTranscript?.map((item, index) => (
                      <div
                        className={classes.columnContainer}
                        key={`T-${index}`}
                        style={{ marginBottom: '1.1rem', gap: '0.2rem' }}
                      >
                        <div className={classes.imageContainer}>
                          {item?.role === 'user' ? (
                            <>
                              <Avatar
                                className={classes.avatar}
                                alt=""
                                src={assigned_by_user?.profile_pic}
                              >
                                {User.getInitial(assigned_by_user) || 'U'}
                              </Avatar>
                              <p>{userName}</p>
                            </>
                          ) : (
                            <>
                              <Avatar
                                className={classes.avatar}
                                alt=""
                                src={client_profile_pic ? client_profile_pic : cat}
                              />
                              <p>{clientName}</p>
                            </>
                          )}
                          <div className={classes.time}>
                            {item?.timestamp.toString().replace('.', ':')}{' '}
                          </div>
                        </div>
                        <div className={classes.rowContainer}>
                          <CopyComponent text={item?.content} />
                        </div>
                      </div>
                    ))
                  ) : (
                    <p style={{ color: '#78909c' }}>No matching results were found</p>
                  )}
                </div>
              </div>
            )}
          </TabPanel>
        </div>
      </div>
    </div>
  );
};

export default ReportResult;
